import { Button } from "@/components/ui/button";
import { ArrowRight, Mail } from "lucide-react";

const GlobalCTA = () => {
  return (
    <section className="py-20 bg-muted/50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold">
            Ready to Build Your Own System?
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            You do not have to navigate the market or the code alone. Choose your path.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <a 
              href="https://marquettas-newsletter.beehiiv.com/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Button 
                size="lg" 
                variant="premium" 
                className="group w-full sm:w-auto"
              >
                <Mail className="w-4 h-4 mr-2" />
                Get the Weekly Intel
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalCTA;
